import vue from 'vue'

export default {
  namespaced: true,
  state: {},
  mutations: {
    save (state, payload) {
      for (let property in payload) {
        vue.set(state, property, payload[property])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ctacte.js